import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/authenticationActions';
import { CodeInput, getSegmentCssWidth } from 'rci';

import BuddyFace from '../../assets/images/buddy-face.png';

const MFAVerification = ({
    checkMFA,
    email,
    logout,
}) => {

    const inputRef = useRef(null);
    const width = getSegmentCssWidth('10px');

    return (
        <div className="holder" style={{ minHeight: "100vh" }}>
            <div className="center" id="login" style={{ height: "100vh", display: "flex", justifyContent: "center" }}>
                <div className="text-center" style={{ alignSelf: "center" }}>
                    <img src={BuddyFace} style={{ marginBottom: "20px", maxWidth: "100px", display: "inline-block" }} />
                    <h5 id="mfa-title" style={{ marginBottom: "30px", fontSize: "16px", fontWeight: "500", lineHeight: "19.2px" }}>Enter your MFA code below ({email})</h5>
                    <CodeInput
                        id="mfa-setup-key"
                        inputRef={inputRef}
                        length={6}
                        spellCheck={false}
                        inputMode='numeric'
                        pattern='[0-9]*'
                        style={{ height: 40, marginBottom: 10 }}
                        inputClassName="mfa-input"
                        className="mfa-div"
                        inputStyle={{ height: 40 }}
                        autoComplete='off'
                        onChange={({ currentTarget: input }) => {
                            // only accept numbers
                            input.value = input.value.replace(/\D+/g, '');

                            if (input.value.length === 6) checkMFA(input.value);
                        }}
                        renderSegment={({ state, index }) => (
                            <div
                                key={index}
                                className='segment'
                                data-state={state}
                                style={{ width, flex: "none", height: '100%', border: "2px solid rgb(209, 213, 219)", borderRadius: "3.75px" }}
                                children={<div />}
                            />
                        )}
                    />
                    <div className="font-s13 text-right push-5-t" style={{ lineHeight: "18.5714px" }}>
		                <a id="go-back" onClick={() => logout()} style={{ cursor: "pointer" }}>Nope, take me back</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        email: state?.my?.profile?.email,
    };
};

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(ACTIONS.logout()),
    checkMFA: (code) => dispatch(ACTIONS.checkMFA(code)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MFAVerification);